export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'fantasy',
    name: '奇幻冒险',
    description: '探索异世界、魔法与勇者的奇幻旅程',
    icon: 'ri-magic-line',
    count: 128,
  },
  {
    slug: 'romance',
    name: '恋爱甜宠',
    description: '甜蜜动人的爱情故事，温暖你的心',
    icon: 'ri-heart-line',
    count: 256,
  },
  {
    slug: 'action',
    name: '动作热血',
    description: '热血沸腾的战斗，激燃的冒险旅程',
    icon: 'ri-fire-line',
    count: 189,
  },
  {
    slug: 'thriller',
    name: '悬疑惊悚',
    description: '扣人心弦的悬疑故事，挑战你的推理能力',
    icon: 'ri-ghost-line',
    count: 95,
  },
  {
    slug: 'scifi',
    name: '科幻未来',
    description: '探索宇宙与未来科技的无限可能',
    icon: 'ri-rocket-line',
    count: 67,
  },
  {
    slug: 'school',
    name: '校园青春',
    description: '青春洋溢的校园日常与成长故事',
    icon: 'ri-building-line',
    count: 142,
  },
  {
    slug: 'wuxia',
    name: '武侠古风',
    description: '刀光剑影的江湖世界，侠义与情仇',
    icon: 'ri-sword-line',
    count: 78,
  },
  {
    slug: 'realistic',
    name: '现实题材',
    description: '深刻反映社会现实的优秀作品',
    icon: 'ri-user-line',
    count: 53,
  },
];